import axios from 'axios'
import router from '@/router';
import { ToastEventBus } from 'primevue'
import { useUnauthMessage } from '@/stores/useUnauthMessage'
import { usePath } from '@/stores/usePath'
import { useUser } from '@/stores/useUser'
import { guriga } from '@/stores/guriga'

const { keres_elinditasa, keres_befejezese } = guriga()
// axios config kibővítése, hogy lehessen tiltani a spinner megjelenítését
declare module "axios" {
  export interface AxiosRequestConfig {
    showSpinner?: boolean
    skip401Redirect?: boolean
  }
}

const api = axios.create({
                          baseURL: import.meta.env.VITE_API_URL,
                          timeout: 15000,
                          withCredentials: true,
                          withXSRFToken: true,
                          xsrfCookieName: 'XSRF-TOKEN',
                          xsrfHeaderName: 'X-XSRF-TOKEN',
                          headers: { Accept: "application/json" },
                        })


let utolsoRateLimitToast = 0
const RATE_LIMIT_TOAST_GYAKORISAG_MS = 4000

const rateLimitToastMegjelenitese = (error: any) => {
  const most = Date.now()
  if (most - utolsoRateLimitToast < RATE_LIMIT_TOAST_GYAKORISAG_MS) return

  utolsoRateLimitToast = most
  ToastEventBus.emit('add', {
    severity: 'warn',
    summary: 'Túl sok kérés',
    detail: 'Túl sok kérést küldött rövid időn belül. Kérjük, várjon egy kicsit, majd próbálja újra.',
    life: 5000,
  })
}

// Kérés hívása előtt indítja a spinnert
api.interceptors.request.use(
  (config) => {
    if (config.showSpinner !== false) {
      keres_elinditasa()
    }
    return config
  },
  (error) => {
    if (error?.config?.showSpinner !== false) {
      keres_befejezese()
    }
    return Promise.reject(error)
  }
)

// Minden response érkezésekor meghívott függvények
api.interceptors.response.use(
  (response) => {
    // Válasz megérkezésekor leállítja a spinnert
    if (response.config.showSpinner !== false) {
      keres_befejezese()
    }
    return response
  },
  (error) => {
    // Válasz megérkezésekor leállítja a spinnert
    if (error?.config?.showSpinner !== false) {
      keres_befejezese()
    }
    const status = error?.response?.status

    if (status === 429) {
      rateLimitToastMegjelenitese(error)
    }
    // Lejárt session esetén visszairányítja a bejelentkezési oldalra
    // (419: CSRF token mismatch — a régi XSRF-TOKEN cookie már lejárt sessionre mutat, ugyanaz az állapot mint a 401)
    if ((status === 401 || status === 419) && !error?.config?.skip401Redirect) {
        const unauth_message = useUnauthMessage()
        unauth_message.setMessage('A munkamenete lejárt, kérjük, jelentkezzen be újra.')
        if (router.currentRoute.value.name === 'mcp_letoltes') {
          usePath().setPath(router.currentRoute.value.fullPath)
        }
        useUser().clear()
        router.push({ name: 'bejelentkezes' })
    }
    return Promise.reject(error)
  }
)

export { api }
